/**
 * @generated SignedSource<<5a547cf887bb899b291e3e7442d11566>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type StatusColumnHeaderOld_project$data = {
  readonly canAdministerProject: {
    readonly canPerform: boolean;
  };
  readonly projectStyle: JiraProjectStyle;
  readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_project">;
  readonly " $fragmentType": "StatusColumnHeaderOld_project";
};
export type StatusColumnHeaderOld_project$key = {
  readonly " $data"?: StatusColumnHeaderOld_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumnHeaderOld_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusColumnHeaderOld_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "canAdministerProject",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
          }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "canPerform"
            },
            "action": "THROW",
            "path": "canAdministerProject.canPerform"
          }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
      },
      "action": "THROW",
      "path": "canAdministerProject"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectStyle"
      },
      "action": "THROW",
      "path": "projectStyle"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardHeaderDropdown_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c582723ff81494d70123540880c68931";

export default node;
